import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';
import { generateLocalizedRouteConfig, LocalizedRoutes } from '../localizedRouting';
import { VALUATION_FORM_PATH } from './constants';

const routes: LocalizedRoutes = {
  de: { path: `${VALUATION_FORM_PATH['de']}` },
  en: { path: `${VALUATION_FORM_PATH['en']}` },
  fr: { path: `${VALUATION_FORM_PATH['fr']}` },
  it: { path: `${VALUATION_FORM_PATH['it']}` },
};

const Component = () =>
  import('@/components/property-details-page/ValuationForm/ValuationForm.vue');

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.PropertyValuationForm);

export default localizedRouteConfig;
